import React from 'react';
import { Eye, X, Lock } from 'lucide-react';
import { isKundenansicht, isKundenansichtFrame, kundenansichtInfo, endKundenansicht } from '@/lib/kundenansicht';

const ROLE = { mieter: 'Mieter', eigentuemer: 'Eigentümer' };

// Leiste oben im Portal, wenn ein Admin/Mitarbeiter das Portal als Kunde ansieht (schreibgeschützt).
// Eingebettet in der Kundenansicht-Vorschau (iframe) übernimmt die Admin-Leiste des Eltern-Fensters diese Rolle → 1:1 Kundenbild.
export const KundenansichtBanner = () => {
  if (!isKundenansicht() || isKundenansichtFrame()) return null;
  const info = kundenansichtInfo() || {};
  return (
    <div data-testid="kundenansicht-banner"
      className="flex-shrink-0 bg-brand-navy text-white px-4 py-2 flex items-center justify-between gap-3 border-b-2 border-brand-gold z-[99995]">
      <div className="flex items-center gap-2.5 min-w-0">
        <Eye className="w-4 h-4 text-brand-gold flex-shrink-0" />
        <p className="text-xs sm:text-sm truncate">
          <span className="font-semibold">Kundenansicht:</span> <span className="hidden sm:inline">Sie sehen das Portal als </span>
          <span className="font-semibold" data-testid="kundenansicht-banner-name">{info.name || 'Kunde'}</span>
          {info.role && <span className="text-white/60 hidden sm:inline"> ({ROLE[info.role] || info.role})</span>}
          <span className="hidden md:inline-flex items-center gap-1 ml-3 text-[11px] text-white/70"><Lock className="w-3 h-3" /> schreibgeschützt – Änderungen werden nicht gespeichert</span>
        </p>
      </div>
      <button onClick={endKundenansicht} data-testid="kundenansicht-end-btn"
        className="flex-shrink-0 inline-flex items-center gap-1.5 px-3 py-1.5 bg-white/10 hover:bg-white/20 rounded-lg text-xs font-medium transition-colors">
        <X className="w-3.5 h-3.5" /> Vorschau beenden
      </button>
    </div>
  );
};

export default KundenansichtBanner;
